export default __webpack_public_path__ + "static/media/report-icon.906c429a.svg";